import PaymentType from "./PaymentType";

class OrderAdditionalPrice {
    public isPercentage: boolean;
    public amount: number;
    public comment: string;
    public paymentType?: PaymentType;

    constructor(amount: number, comment: string, isPercentage: boolean, paymentType?: PaymentType) {
        this.isPercentage = isPercentage;
        this.amount = amount;
        this.comment = comment;
        this.paymentType = paymentType;
    }

}

export default OrderAdditionalPrice;